export function PracticeTaskGrooveChoice({ disabled, onChoose }: {
  disabled: boolean;
  onChoose: () => void;
}) {
  return <div className="stack practice-task-groove-choice">
    <button type="button" className="secondary" disabled={disabled} onClick={onChoose}>Choose a drum groove</button>
    <p className="small muted">Choose a saved groove from the Groove library to set as a playable practice task. Your text task is kept while you choose.</p>
  </div>;
}
